import mixins from 'vue-typed-mixins';
import { PropType } from 'vue';
import _ from 'lodash';

import { E償却方法 } from '@/openapi/enum';
import { データApi } from '@/openapi/user';

import AlertMixin from '@/mixins/AlertMixin';
import ListMixin from '@/entries/user/mixins/ListMixin';
import フェーズ種別Mixin from '@/entries/user/mixins/フェーズ種別Mixin';

import UserApiUtility from '@/classes/common/UserApiUtility';
import { 償却List, 償却ListItem } from '@/classes/service/分析計画/償却Type';

export default mixins(AlertMixin, ListMixin, フェーズ種別Mixin).extend({
  name: 'C償却List',

  props: {
    list: {
      type: Object as PropType<償却List>,
    },
    /** 簡易表示 */
    isSimple: {
      type: Boolean,
      default: false,
    },
    /** 編集・削除ボタン表示 */
    canEdit: {
      type: Boolean,
      default: true,
    },
    /** 編集中item（選択状態切り替えのため） */
    selectedItem: {
      type: Object as PropType<償却ListItem | null>,
      default: null,
    },
    unit: {
      type: Number,
      required: false,
    },
  },

  computed: {
    editItemPk(): number | undefined {
      if (this.selectedItem === null) return undefined;
      return this.selectedItem.データpk;
    },
  },

  methods: {
    is定率法(item: 償却ListItem): boolean {
      return item.償却方法 === E償却方法.定率法200pct || item.償却方法 === E償却方法.定率法250pct;
    },
    isリース期間定額法(item: 償却ListItem): boolean {
      return item.償却方法 === E償却方法.リース期間定額法;
    },
    async remove(データpk: number): Promise<void> {
      const isCancelOrError = await this.isCancelOrValidationErrorResponseToDelete(() =>
        UserApiUtility.ogApi(データApi).deleteデータ(データpk)
      );
      if (isCancelOrError) return;
      this.$emit('clearItem');
    },
  },
});
